<template>
  
  <div class="group" :ref="refs['widthGroup']" data-id="widthGroup">

    <div class="group-header">
      <div class="group-title">What are the measurements of the wardrobe?</div>
      <div class="group-help">Not sure? <a href="/support/how-to-measure/" target="_blank">See how to measure.</a></div>
    </div>

    <div class="group-inputs">

      <div class="group-input l_height" :ref="refs['heightGroup']">

        <Input
        key="height"
        field-label="Ceiling Height"
        field-name="height"
        field-type="number"
        :init-value=builder.currentItem.specs.height
        :max=builder.currentProductStructure.height.max
        :min=builder.currentProductStructure.height.min
        :required="true"
        scope="specs"
        @update-value="updateValue"
        @update-non-standard="updateNonStandard"
        ></Input>

      </div>

      <div class="group-input l_x l_shrink">
        <svg class="icon"><use href="#cross"></use></svg>
      </div>

      <div class="group-input" :ref="refs['widthGroup']">

        <Input
        key="width"
        field-label="Width"
        field-name="width"
        field-type="number"
        :init-value=builder.currentItem.specs.width
        :max=builder.currentProductStructure.width.max
        :min=builder.currentProductStructure.width.min
        :required="true"
        scope="specs"
        @update-value="updateValue"
        @update-non-standard="updateNonStandard"
        ></Input>

      </div>

    </div>
    
    <div class="group-footer l_text-center">            

      <div class="styledcheckbox group-checkbox">
        <input
          type="checkbox"
          name="levelsOut"
          id="levelsOut"
          value="1"
          :true-value="true"
          :false-value="false"
          v-model="builder.currentItem.specs.levelsOut" />
        <label for="levelsOut">
          <span class="checkbox-value">My levels are out more than 8mm</span>
        </label>
      </div>
      
    </div>
  
    <div class="group-footer l_text-center">
      
      <p>Overall Depth:&nbsp;&nbsp;600mm</p>
      
      <small>To maintain an economical product all internal board is 442mm and the overall depth is 600mm.</small>
    
    </div>
  
    <div class="group-footer l_text-center" v-if="isNonStandard">
      
      <p><strong>You've given us a size that's non-standard.</strong><br />Please <a href="https://packers.com.au/request-a-quote/" target="_blank" class="l_inherit-color">request a quote</a> and a Packers wardrobe designer will be in&nbsp;contact.</p>
      
      <a href="https://packers.com.au/request-a-quote/" target="_blank" class="btn">Request a quote from&nbsp;Packers</a>
    </div>
    
  </div>
  
</template>

<script setup>
  
import { computed, ref } from 'vue'

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();

const nonStandard = ref({
  width: false,
  height: false
});

function updateValue(prop, val) {
  builder.setCurrentItemSpec(prop, val);
}

function updateNonStandard(prop, val) {
  nonStandard.value[prop] = val;
}

const isNonStandard = computed(() => {
  if (nonStandard.value.width || nonStandard.value.height) return true;
  return false;
})

// init refs
let refHandles = [
  'widthGroup',
];
const refs = _.chain(refHandles).keyBy().mapValues(ref).value();
refHandles.forEach(item => {
  builder.refs[item] = refs[item];
});
</script>